export default __webpack_public_path__ + "static/media/turkgot-screenshot-02.238aa692.png";